import ReactGA from 'react-ga';

let isGAReady = false;

export function initializeAnalytics(trackingId: string) {
  ReactGA.initialize(trackingId);
  isGAReady = true;
  ReactGA.pageview(window.location.pathname + window.location.search);
  console.log('Google Analytics initialized');
}

export function trackEvent(event: {
  category: string;
  action: string;
  label?: string;
}) {
  if (!isGAReady) {
    const consentCookie = document.cookie
      .split("; ")
      .find(row => row.startsWith("CookieConsent="));

    if (consentCookie === "true") {
      console.warn('[GA] Not initialized or not activated, skipping event:', event);
      return;
    }
  }

  ReactGA.event(event);
}